import React, {FC} from 'react';

import {Trans} from '../../../libs/shared/helpers/src/internationalization/react';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {InfoBubble, InfoBubbleInstanceProps} from '../common/infoBubbles/infoBubble';
import {InfoBubbleContent} from '../common/infoBubbles/infoBubbleContent';
import {InfoBubbleDescription} from '../common/infoBubbles/infoBubbleContentDescription';
import {InfoBubbleTitle} from '../common/infoBubbles/infoBubbleContentTitle';
import {InfoBubbleFooterActions} from '../common/infoBubbles/infoBubbleFooterActions';
import {useInfoBubblesContext} from '../common/infoBubbles/infoBubblesContext';

/*
 * Component.
 */

export const FirstConversationArchiveInfoBubble: FC<InfoBubbleInstanceProps> = ({targetRef}) => {
  const context = useInfoBubblesContext();
  const onClose = () => {
    context.closeInfoBubbles(OnboardingTipTypesEnum.FIRST_CONVERSATION_ARCHIVE);
  };

  return (
    <InfoBubble
      {...context}
      position="bottom"
      type={OnboardingTipTypesEnum.FIRST_CONVERSATION_ARCHIVE}
      targetRef={targetRef}
      isInteractive
      interactionId="first-conversation-archive"
    >
      <InfoBubbleContent>
        <InfoBubbleTitle>
          <Trans id="infobubble-first-conversation-archive-title">Go ahead and archive!</Trans>
        </InfoBubbleTitle>
        <InfoBubbleDescription>
          <Trans id="infobubble-first-conversation-archive-description">
            Archiving is the Front-recommended way of working. Don&apos;t worry, the conversation will reopen
            if there are any new replies or comments.
          </Trans>
        </InfoBubbleDescription>
        <InfoBubbleFooterActions>
          <Button
            onClick={onClose}
            size={VisualSizesEnum.MEDIUM}
            color={PaletteColorsEnum.PINK}
            variant={ButtonVariantsEnum.CUSTOM}
          >
            <Trans id="infobubble-first-conversation-archive-cta">Got it!</Trans>
          </Button>
        </InfoBubbleFooterActions>
      </InfoBubbleContent>
    </InfoBubble>
  );
};
